import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetWhatIfStoryView } from 'src/core/repo/whatif/useCase';

import { getWhatIfStoryDetailsTransformer  , getMobileWhatIfStoryDetailsTransformer} from '@coreStory/transformer';
import WebView from './_components/webView/WebView';
import MobileView from './_components/mobileView/MobileView';
import styles from './index.module.scss';

const WhatIfStoryPage = () => {
  // Modal state
  const [isVisibilityModalVisible, setIsVisibilityModalVisible] =
    useState(false);

  const width = window.innerWidth;
  const { id } = useParams();
  const navigate = useNavigate();

  const { mutate, data } = useGetWhatIfStoryView();

  // Function to refresh story data
  const refreshStoryData = () => {
    if (id) {
      mutate({ story_id: Number(id) });
    }
  };

  // Button handlers
  const handleSetVisibility = () => {
    setIsVisibilityModalVisible(true);
  };

  useEffect(() => {
    if (!id) navigate('/dashboard');

    mutate(
      { story_id: Number(id) },
      {
        onSettled(data) {
          console.log(data);
        },
      },
    );
  }, [id]);

  return (
    <div>
      <div className={styles.title}>{data?.[0]?.StoryName}</div>
      {width > 1000 ? (
        <WebView
          storyData={getWhatIfStoryDetailsTransformer(data || [])}
          onStoryUpdated={refreshStoryData}
          onSetVisibility={handleSetVisibility}
        />
      ) : (
        <MobileView
          storyData={getMobileWhatIfStoryDetailsTransformer(data || [])}
          onStoryUpdated={refreshStoryData}
          onSetVisibility={handleSetVisibility}
        />
      )}
    </div>
  );
};

export default WhatIfStoryPage;
